import React from 'react';
import get from 'lodash/get';
import { Provider } from 'react-redux';

import Layout from 'app/layout';
import Auth from 'app/auth';

import DeveloperError from './developer-error';
import AsyncRenderer from './components/async-renderer';
import { Store } from 'redux';

/* istanbul ignore next */
const buildError = ( componentStack: string, errorStack: string|undefined ) =>
`An error occurred in component tree: ${componentStack}

${errorStack}`;

interface Props {
    store: Store;
}
interface State {
    hasError: boolean;
    errorStack: string;
}

export default class App extends React.Component<Props, State> {

    public state = {
        hasError: false,
        errorStack: '',
    };

    public componentDidCatch = /* istanbul ignore next */ ( error: Error, info: any ) => {
        this.setState( {
            hasError: true,
            errorStack: buildError( get( info, 'componentStack', '' ), error.stack ),
        } );
    }

    public render() {
        if ( DEVELOPMENT && this.state.hasError ) { // eslint-disable-line no-undef
            return <DeveloperError errorStack={this.state.errorStack} />;
        }

        const { store } = this.props;
        return (
            <Provider store={store}>
                <Auth>
                    <Layout>
                        <AsyncRenderer />
                    </Layout>
                </Auth>
            </Provider>
        );
    }
}
